import type { CampaignStatus, SendMode } from '@/features/marketing-shared';
import type { Campaign } from '@/shared/types/campaign';
import type { MarketingCampaignRow } from '@/features/marketing-shared/model/campaign-filters';

export function isPushCampaign(campaign: Campaign): boolean {
  const channel = (campaign.tipo_disparo ?? 'push').trim().toLowerCase();
  return channel === '' || channel === 'push';
}

function pushStatus(campaign: Campaign): CampaignStatus {
  if (campaign.active === false) return 'paused';
  if (campaign.ultimo_status === 'error') return 'failed';
  if (campaign.ultimo_status === 'running') return 'sending';
  if (campaign.ultimo_status === 'success') return 'sent';
  return 'scheduled';
}

function pushSendMode(campaign: Campaign): SendMode | null {
  if (!campaign.frequencia) return null;
  return campaign.frequencia === '31' ? 'later' : 'now';
}

export function toPushRow(campaign: Campaign): MarketingCampaignRow {
  return {
    id: campaign._id,
    name: campaign.name?.trim() || 'Campanha sem nome',
    status: pushStatus(campaign),
    audienceName: campaign.atividade ? `Atividade ${campaign.atividade}` : 'Audiência da loja',
    eligible: campaign.total_recebidos ?? campaign.received,
    scheduledAt: campaign.frequencia_unico || null,
    createdAt: campaign.created_at ?? campaign.updated ?? null,
    sendMode: pushSendMode(campaign),
    sent: campaign.total_recebidos ?? campaign.received,
  };
}
